module.exports = __webpack_public_path__ + "static/img/230825_BB_WaterlemonLime_Smiley_Anim01_2.d5802b2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/230825_BB_WaterlemonLime_Smiley_Anim01_2.gif
// module id = QuAJ
// module chunks = 0